import React from 'react'


const CostList = ({ data = [], currencyLabel = "AED" }) => {
    return (
        <ul className="md-bar-graphlist" style={{ marginTop: 0 }}>
            {data.map((item, index) => (
                <li
                    key={index}
                    style={{
                        backgroundColor: "#0A83A1",
                        borderRadius: "8px",
                        margin: "4px 0 0 0",
                        height: "36px",
                        color: "white",
                        listStyle: "none",
                    }}
                >
                    <span
                        style={{
                            fontSize: 12,
                            fontWeight: 400,
                            padding: "7px 12px",
                        }}
                    >
                        <span>{item.name === "car" ? "SEDAN" : item.name?.toUpperCase()}</span>
                        <br />
                        <strong style={{ marginLeft: "10px" }}>
                            {(() => {
                                try {
                                    const realValue = item?.cost;
                                    const integerAmount = Math.floor(realValue);
                                    const formattedAmount = integerAmount.toLocaleString();
                                    return (
                                        <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                                            {formattedAmount} {currencyLabel}
                                        </span>
                                    );
                                } catch (error) {
                                    console.error("Error:", error);
                                    return "Error";
                                }
                            })()}
                        </strong>
                    </span>
                </li>
            ))}
        </ul>
    );
};

export default CostList